module.exports = __webpack_public_path__ + "static/media/skdzzLogo.d06a9fe4.png";